export default {
    'create-warehouse': 'Crear almacén',
    'edit-warehouse': 'Editar almacén',
    'warehouse-name': 'Nombre de almacén',
    notes: 'Notas',
    save: 'Guardar',
    cancel: 'Cancelar',

    'delete-the-warehouse': 'Eliminar almacén',
    'are-you-sure-you-want-to-delete-the-warehouse': '¿Estas seguro de eliminar almacén?',

    headers: {
        'no': 'Número',
        'warehouse-name': 'Nombre de almacén',
        'notes': 'Notas',
        'actions': 'Acciones',
    }
}